<template>
  <section class="preview">
    <form novalidate @submit.prevent="crear">
      <mdb-input
        label="Código"
        class="mb-3 mt-0"
        v-model="code"
        required
        invalidFeedback="Coloca el codigo"
      ></mdb-input>

      

      <mdb-input
        type="text"
        label="Regla"
        class="mb-3 mt-0"
        v-model="raw_rule"
        required
        invalidFeedback="coloca la regla"
      ></mdb-input>

       <mdb-input
        type="text"
        label="Nombre"
        class="mb-3 mt-0"
        v-model="name"
        required
        invalidFeedback="coloca el nombre"
      ></mdb-input>

       <div class="form-group">
            <b-form-checkbox
            id="checkbox-1"
            v-model="is_value_based"
            name="checkbox-1"
            >
            Basada en el valor
            </b-form-checkbox>
        </div>

        <div class="form-group">
        <label class="typo__label">Subtipo de audiencia</label>
        <multiselect
          v-model="subtype"
          placeholder="Seleccione el País"
          label="name"
          track-by="value"
          :options="subtypes"
          :multiple="false"
          :taggable="false"
        ></multiselect>
      </div>

        <mdb-input
        type="number"
        label="Días de retención"
        class="mb-3 mt-0"
        v-model="retention_days"
        required
        invalidFeedback="Regla"
      ></mdb-input>

      <div class="form-group">
        <label class="typo__label">País</label>
        <multiselect
          v-model="selectedCountry"
          placeholder="Seleccione el País"
          label="name"
          track-by="id"
          :options="countries"
          :multiple="false"
          :taggable="false"
        ></multiselect>
      </div>

      <div class="form-group">
        <label class="typo__label">Pixel</label>
        <multiselect
          v-model="pixel"
          placeholder="Seleccione el País"
          label="pixel_code"
          track-by="id"
          :options="pixels"
          :multiple="false"
          :taggable="false"
        ></multiselect>
      </div>

      <div class="form-group">
        <label class="typo__label">Cuenta de anuncios</label>
        <multiselect
          v-model="ad_account"
          placeholder="Seleccione el País"
          label="name"
          track-by="id"
          :options="ad_accounts"
          :multiple="false"
          :taggable="false"
        ></multiselect>
      </div>

      <!--<label>Estrategias</label>
      <multiselect
        v-model="strategyActionsSelected"
        placeholder="Estrategias de acción"
        class="mb-3"
        label="name"
        track-by="id"
        :options="strategyActions"
        :multiple="true"
      ></multiselect>-->


      <div class="text-center">
        <mdb-btn type="submit" color="primary" :disabled="isLoading">
          <span v-if="!isLoading">Crear</span>
          <semipolar-spinner :animation-duration="2000" :size="30" color="#ffffff" v-if="isLoading"></semipolar-spinner>
        </mdb-btn>
      </div>
    </form>
  </section>
</template>

<script>
import { mdbInput, mdbBtn } from "mdbvue";
import { SemipolarSpinner } from "epic-spinners";
import Multiselect from "vue-multiselect";
import store from "../../store";
export default {
  name: "modal-2",
  components: {
    mdbInput,
    Multiselect,
    mdbBtn,
    SemipolarSpinner,
    
  },
  props: {
    onClick: Function
  },
  data: () => {
    return {
      isLoading: false,
      is_value_based:false,
      code: "",
      raw_rule:"",
      countries: [],
      pixels:[],
      pixel:{},
      subtype:{},
      subtypes:[
          {name:"APP",value:"APP"},
          {name:"APP_COMBINATION",value:"APP_COMBINATION"},
          {name:"CUSTOM",value:"CUSTOM"},
          {name:"LOOKALIKE",value:"LOOKALIKE"},
          {name:"MANAGED",value:"MANAGED"},
          {name:"ENGAGEMENT",value:"ENGAGEMENT"},
          {name:"IG_BUSINESS",value:"IG_BUSINESS"},
          {name:"PARTNER",value:"PARTNER"},
          {name:"VIDEO",value:"VIDEO"},
          {name:"WEBSITE",value:"WEBSITE"},
      ],
      ad_accounts:[],
      ad_account:{},
      name:"",
      retention_days: 0,
      selectedCountry: {}
    };
  },
  async mounted() {
    var respuesta = await this.getCountries();
    respuesta = await this.getPixels()
    respuesta = await this.getAccounts()
    
  },
  methods: {
    crear(event) {
      event.target.classList.add("was-validated");
      var { name, code,retention_days, raw_rule,pixel,ad_account,selectedCountry,subtype,is_value_based } = this;
      this.isLoading = true;
      if (
          name == "" ||
          code == "" ||
          raw_rule == "" 
          ) {
        this.isLoading = false;
      } else {
        var audiencia = {
          name,
          retention_days,
          code,
          ad_account,
          pixel,
          country:selectedCountry,
          subtype,
          is_value_based,
          raw_rule
        };
        store.dispatch("newAudiencia", audiencia).then(() => {
          this.name = "";
          this.code = "";
          this.ad_account = "";
          this.ad_account = {},
          this.selectedCountry = {}
          this.subtype = {}
          this.onClick();
          this.isLoading = false;
        });
      }
    },
    async getCountries() {
      var countries = store.getters.getCountries;
      if (countries.length == 0) {
        await store.dispatch("getCountries").then(() => {
          countries = store.getters.getCountries;
          this.countries = countries;
          return;
        });
      } else {
        this.countries = countries;
        return;
      }
    },
    async getPixels() {
      var pixels = store.getters.getAllPixels;
      if (pixels.length == 0) {
        await store.dispatch("getAllPixels").then(() => {
          pixels = store.getters.getAllPixels;
          this.pixels = pixels;
        });
      } else {
        this.pixels = pixels;
      }
    },
    async getStrategyActions() {
      var strategyActions = store.getters.getStrategyActions;
      if (strategyActions.length == 0) {
        store.dispatch("getStrategyActions").then(() => {
          strategyActions = store.getters.getStrategyActions;
          this.strategyActions = strategyActions;
          return;
        });
      } else {
        this.strategyActions = strategyActions;
        return;
      }
    },
    async getAccounts(){
      var ad_accounts = store.getters.getAdsAccounts;
      if (ad_accounts.length == 0) {
        await store.dispatch("getAdsAccounts").then(() => {
          ad_accounts = store.getters.getAdsAccounts;
          this.ad_accounts = ad_accounts;
          return;
        });
      } else {
        this.ad_accounts = ad_accounts;
        return;
      }
    },
    async getLines() {
      var lines = store.getters.getLines;
      if (lines.length == 0) {
        await store.dispatch("getLines").then(() => {
          lines = store.getters.getLines;
          this.lines = lines;
          return;
        });
      } else {
        this.lines = lines;
        return;
      }
    },
    async getPartners() {
      var partners = store.getters.getPartners;
      if (partners.length == 0) {
        store.dispatch("getPartners").then(() => {
          partners = store.getters.getPartners;
          this.partners = partners;
        });
      } else {
        this.partners = partners;
      }
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
</style>